import {
  ScheduleGetAvailabilityResponseDto,
  ScheduleTimeSlot,
} from '../../services/api/types/schedule';
import {
  InputAnswer,
  StepAnswers,
} from '../../store/reducers/types/form.types';
import {
  getBrowserCountryAlpha2FromTimezone,
  getBrowserTimezone,
} from '../PhoneInput/codes';

export function getWeekDays(currentDate: Date, days = 7) {
  const weekDays = [];
  const startDate = new Date(currentDate);

  for (let i = 0; i < days; i++) {
    const day = new Date(startDate);
    day.setDate(startDate.getDate() + i);
    weekDays.push(day);
  }

  return weekDays;
}

export function isSameDay(date1: Date, date2: Date) {
  return (
    date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate()
  );
}

export function isSameTimeSlot(
  slot1: ScheduleTimeSlot,
  slot2: ScheduleTimeSlot,
) {
  return slot1.startTime === slot2.startTime && slot1.endTime === slot2.endTime;
}

export function getOffsetFromDate(findDate: Date, weekDays = 7) {
  const today = new Date();
  let offset = 0;
  do {
    const weekDaysList = getWeekDays(today, weekDays);
    const foundIndex = weekDaysList.findIndex((day) =>
      isSameDay(day, findDate),
    );
    if (foundIndex !== -1) {
      return offset;
    }
    offset += weekDays;
    today.setDate(today.getDate() + weekDays);
    // eslint-disable-next-line no-unmodified-loop-condition
  } while (today.getTime() <= findDate.getTime());
  return 0;
}

export function checkIfAnswerIsSchedule(inputAnswer: InputAnswer): boolean {
  if (
    inputAnswer?.value &&
    typeof inputAnswer.value === 'object' &&
    'startTime' in inputAnswer.value &&
    'endTime' in inputAnswer.value
  ) {
    return true;
  }
  return false;
}

export function getHorizontalScrollPercent(element: Element) {
  if (!element) return 0;

  const scrollLeft = element.scrollLeft;
  const scrollWidth = element.scrollWidth - element.clientWidth;

  if (scrollWidth === 0) return 0; // Avoid division by zero

  return (scrollLeft / scrollWidth) * 100;
}

export function elementsCrash(el1: Element, el2: Element) {
  if (!el1 || !el2) return false;

  const r1 = el1.getBoundingClientRect();
  const r2 = el2.getBoundingClientRect();

  return !(
    (
      r1.right < r2.left || // el1 is completely left of el2
      r1.left > r2.right || // el1 is completely right of el2
      r1.bottom < r2.top || // el1 is completely above el2
      r1.top > r2.bottom
    ) // el1 is completely below el2
  );
}

export function generateDummyAvailability(): ScheduleGetAvailabilityResponseDto {
  const availability = [];
  const today = new Date();

  for (let i = 0; i < 14; i++) {
    const date = new Date(today);
    date.setDate(today.getDate() + i);
    const dateString = date.toISOString().split('T')[0];

    const times: ScheduleTimeSlot[] = [];
    for (let hour = 9; hour < 17; hour++) {
      times.push({
        startTime: `${dateString}T${hour.toString().padStart(2, '0')}:00:00`,
        endTime: `${dateString}T${(hour + 1)
          .toString()
          .padStart(2, '0')}:00:00`,
      });
    }
    availability.push({
      date: dateString,
      times,
    });
  }
  return {
    availability,
    timezone: getBrowserTimezone(),
  };
}
